import { ref } from 'vue'

import type { ApiBlock } from '@backmarket/http-api/src/api-specs-content/models/block'

export type CmsSections = Record<
  'section1' | 'section2' | 'section3' | 'section4',
  ApiBlock[]
>

export function useFetchCmsSections() {
  const data = ref<CmsSections>({
    section1: [],
    section2: [],
    section3: [],
    section4: [],
  })

  return { data }
}
